import styled from 'styled-components';


export const Wrap = styled.div`
  position: relative;
  user-select: none;
  cursor: default;
`

export const IconWrap = styled.div`
  width: 40px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;

  > svg {
    fill: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`

export const MsgWrap = styled.div`
  width: 100%;
  padding: 9px 40px;
  box-sizing: border-box;
  
  p {
    margin: 0;
    color: #fff;
    font-size: 15px;
    line-height: 20px;
    white-space: pre-wrap;
  }
`

export const BtnWrap = styled.div`
  width: 40px;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.3);
  }

  > svg {
    fill: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`


// WEBPACK FOOTER //
// ./client/components/Toast/Message/styled.js